export default __webpack_public_path__ + "static/media/team.f0fad3fb.svg";